import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import configVuetify from '../config/vuetify';

Vue.use(Vuetify);

export default new Vuetify(configVuetify.vuetify);
